<template>
  <div class="side-menu-container">
    <el-menu
      :default-active="activeIndex"
      :collapse="false"
      mode="vertical"
      background-color="#2f344d"
      text-color="#fff"
      active-text-color="#409EFF"
      :default-openeds="defaultOpeneds"
    >
      <template v-for="item in menuList" :key="item.name">
        <el-sub-menu v-if="item?.sub?.length" :index="item.name">
          <template #title>{{ $t(item.name) }}</template>
          <el-menu-item :index="i.name" v-for="i in item.sub" :key="i.name" @click="jump(i)">
            {{ $t(i.name) }}
          </el-menu-item>
        </el-sub-menu>

        <el-menu-item v-else :index="item.name" @click="jump(item)">
          {{ $t(item.name) }}
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { ref, reactive, computed, onMounted, onUnmounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { rootStore } from '@/store/rootStore';

const store = rootStore();
const { isManager, isBackendManagerOrDeveloper, isBackendPermissionAllocator, userInfo } = storeToRefs(store);

const menuList = computed(() => {
  let tmp = [
    {
      name: '後台入口',
      path: '/',
    },
  ];

  if (isManager.value) {
    tmp = tmp.concat([
      {
        name: '用戶管理',
        path: '/userManage',
      },
      {
        name: '後台管理',
        path: '/backendManage',
      },
      {
        name: '權限管理',
        sub: [
          {
            name: '用戶權限',
            path: '/userAuth',
          },
          {
            name: '權限點',
            path: '/pointAuth',
          },
        ],
      },
      {
        name: '日誌管理',
        sub: [
          {
            name: '登入日誌',
            path: '/loginLog',
          },
          {
            name: '介面訪問日誌',
            path: '/visitLog',
          },
          {
            name: '後台訪問日誌',
            path: '/backendLog',
          },
          {
            name: '鑑權日誌',
            path: '/authLog',
          },
          {
            name: '操作日誌',
            path: '/operationLog',
          },
        ],
      },
    ]);
  }
  if (isBackendPermissionAllocator.value) {
    tmp = tmp.concat([
      {
        name: '後台管理',
        path: '/backendManage',
      },
    ]);
  }
  if (isBackendManagerOrDeveloper.value || isBackendPermissionAllocator.value) {
    tmp = tmp.concat([
      {
        name: '權限管理',
        sub: [
          {
            name: '用戶權限',
            path: '/userAuth',
          },
          {
            name: '權限點',
            path: '/pointAuth',
          },
        ],
      },
    ]);
  }
  // 触达模块，北洛、多拉、华昱权限开放
  const reachSpecialPermission = ['157329214500000040', '160444810800000090', '161040976100000030'].includes(
    userInfo.value?.id
  );
  if (isManager.value || reachSpecialPermission) {
    tmp = tmp.concat([
      {
        name: '觸達管理',
        sub: [
          {
            name: '系統訊息',
            path: '/reachMange',
          },
        ],
      },
    ]);
  }
  // 根据name去重
  return [...new Map(tmp.map((item) => [item.name, item])).values()];
});

const defaultOpeneds = ['權限管理', '日誌管理', '觸達管理'];

const router = useRouter();
const route = useRoute();

const activeIndex = computed(() => {
  return menuList.value
    .map((i) => i?.sub || i)
    .flat()
    .find((i) => i.path === route.path)?.name;
});
const jump = (item) => {
  if (item?.sub?.length > 0) {
    return false;
  }
  router.push(item.path);
};
</script>

<style lang="less">
.side-menu-container {
  padding-bottom: 10px;
}
</style>
